import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { logout } from '../../utils/auth';

const V2 = '/images/dashboard-v2';
const HT = {
  yellow: '#FFD166', yellowShadow: '#E0B554', cream: '#FFF8E7',
  coral: '#FF8C42', brownDark: '#6B4F2B',
  text: '#2D2D2D', textSoft: '#6B6B6B', textMuted: '#9A9A9A',
  white: '#FFFFFF', greenDark: '#5E9E3E',
};
const FONT_DISPLAY = '"Fredoka", "Baloo 2", "Nunito", sans-serif';
const FONT_BODY = '"Nunito", "Baloo 2", sans-serif';
const SHADOW_SM = '0 2px 6px rgba(139,111,71,0.08)';

const HEADER_NAV = [
  { label: 'Trang Chủ', emoji: '🏠', url: '/dashboard' },
  { label: 'Đề Thi Thử', emoji: '📄', url: '/full-mock-test' },
  { label: 'Sổ Từ', emoji: '📖', url: '/vocab/words' },
  { label: 'Báo Cáo Tuần', emoji: '📊', url: '/report' },
  { label: 'Cài Đặt', emoji: '⚙️', url: '/settings' },
];

const AppHeader = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const userName = localStorage.getItem('userFullName') || 'Minh';
  const [showUserMenu, setShowUserMenu] = useState(false);
  const userMenuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (userMenuRef.current && !userMenuRef.current.contains(e.target)) {
        setShowUserMenu(false);
      }
    };
    if (showUserMenu) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showUserMenu]);

  const isActive = (url) => {
    if (url === '/dashboard') return pathname === '/' || pathname === '/dashboard';
    return pathname === url || pathname.startsWith(url + '/');
  };

  return (
    <header style={{
      position: 'relative', background: HT.cream,
      borderBottom: `4px solid ${HT.yellow}`,
      boxShadow: SHADOW_SM,
      fontFamily: FONT_BODY,
    }}>
      {/* Ribbon decorations at viewport corners */}
      <img src={`${V2}/ribbon-left.png`} alt="" aria-hidden="true" style={{
        position: 'absolute', top: 0, left: 0,
        width: 126, height: 'auto',
        pointerEvents: 'none', zIndex: 0,
        filter: 'drop-shadow(0 2px 3px rgba(139,111,71,0.15))',
      }} />
      <img src={`${V2}/ribbon-left.png`} alt="" aria-hidden="true" style={{
        position: 'absolute', top: 0, right: 0,
        width: 126, height: 'auto',
        transform: 'scaleX(-1)',
        pointerEvents: 'none', zIndex: 0,
        filter: 'drop-shadow(0 2px 3px rgba(139,111,71,0.15))',
      }} />

      {/* Inner — aligned with page content max-width 1440 */}
      <div
        className="px-4 md:px-10"
        style={{
          maxWidth: 1440, margin: '0 auto',
          paddingTop: 6, paddingBottom: 6,
          display: 'flex', alignItems: 'center', gap: 16,
          position: 'relative',
        }}
      >
        <div onClick={() => navigate('/dashboard')} style={{
          display: 'inline-flex', alignItems: 'center',
          gap: 2, lineHeight: 1,
          fontFamily: FONT_DISPLAY, fontWeight: 700, fontSize: 22,
          color: HT.greenDark, cursor: 'pointer',
          padding: '3px 16px 3px 3px',
          background: HT.white,
          border: `2px solid ${HT.yellow}`,
          borderRadius: 999,
          boxShadow: `0 3px 0 ${HT.yellowShadow}`,
          position: 'relative', zIndex: 1,
          flexShrink: 0,
        }}>
          <img src={`${V2}/owl-mini.png`} alt="HuPath" style={{ width: 48, height: 48, objectFit: 'contain', display: 'block', flexShrink: 0 }} />
          <span style={{ display: 'inline-flex', alignItems: 'center' }}>HuPath</span>
        </div>
        <nav
          className="hidden lg:flex"
          style={{
            gap: 6, flex: 1, justifyContent: 'center',
            position: 'relative', zIndex: 1,
            flexWrap: 'wrap',
          }}
        >
          {HEADER_NAV.map((item, i) => {
            const active = isActive(item.url);
            return (
              <a key={i} href={item.url} onClick={(e) => { e.preventDefault(); navigate(item.url); }} style={{
                display: 'flex', alignItems: 'center', gap: 6,
                padding: '8px 16px', borderRadius: 999,
                fontWeight: 600, fontSize: 14,
                color: active ? HT.brownDark : HT.textSoft,
                background: active ? HT.yellow : 'transparent',
                boxShadow: active ? `0 3px 0 ${HT.yellowShadow}` : 'none',
                textDecoration: 'none', whiteSpace: 'nowrap',
              }}>
                <span style={{ fontSize: 16 }}>{item.emoji}</span>
                {item.label}
              </a>
            );
          })}
        </nav>
        <div ref={userMenuRef} style={{ marginLeft: 'auto', position: 'relative', zIndex: 10, flexShrink: 0 }}>
          <div
            onClick={() => setShowUserMenu((v) => !v)}
            style={{
              display: 'flex', alignItems: 'center', gap: 8,
              padding: '4px 12px 4px 4px',
              border: `2px solid ${HT.yellow}`, borderRadius: 999,
              background: HT.white, fontWeight: 600, fontSize: 13,
              cursor: 'pointer', userSelect: 'none',
            }}
          >
            <div style={{
              width: 32, height: 32, borderRadius: '50%',
              background: HT.coral, display: 'flex',
              alignItems: 'center', justifyContent: 'center', flexShrink: 0,
              color: 'white', fontWeight: 700, fontSize: 13,
            }}>{(userName[0] || 'U').toUpperCase()}</div>
            <span className="hidden sm:inline" style={{ maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: HT.text }}>{userName}</span>
            <span style={{ color: HT.textMuted, fontSize: 11, flexShrink: 0 }}>▼</span>
          </div>
          {showUserMenu && (
            <div style={{
              position: 'absolute', top: 'calc(100% + 8px)', right: 0,
              background: HT.white, borderRadius: 12,
              border: `2px solid ${HT.yellow}`,
              boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
              minWidth: 160, overflow: 'hidden',
              fontFamily: FONT_BODY,
            }}>
              <button onClick={() => { setShowUserMenu(false); navigate('/settings'); }} style={{
                display: 'flex', alignItems: 'center', gap: 10, width: '100%',
                padding: '12px 16px', border: 'none', background: 'transparent',
                cursor: 'pointer', fontSize: 14, fontWeight: 600, color: HT.text,
                fontFamily: FONT_BODY,
              }}
                onMouseEnter={(e) => e.currentTarget.style.background = HT.cream}
                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
              >
                <span style={{ fontSize: 16 }}>⚙️</span> Cài Đặt
              </button>
              <div style={{ height: 1, background: HT.yellow, opacity: 0.4 }} />
              <button onClick={() => { setShowUserMenu(false); logout(navigate); }} style={{
                display: 'flex', alignItems: 'center', gap: 10, width: '100%',
                padding: '12px 16px', border: 'none', background: 'transparent',
                cursor: 'pointer', fontSize: 14, fontWeight: 600, color: '#D64545',
                fontFamily: FONT_BODY,
              }}
                onMouseEnter={(e) => e.currentTarget.style.background = '#fef2f2'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
              >
                <span style={{ fontSize: 16 }}>🚪</span> Đăng Xuất
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default AppHeader;
